import { HeroButton } from '@/components/ui/hero-button';

interface NewStoryHeroProps {
  onClick: () => void;
  isLoading?: boolean;
  className?: string;
  title?: string;
  ariaLabel?: string;
  dataTour?: string;
  disabled?: boolean;
  blockedLabel?: string;
}

export function NewStoryHero({
  onClick,
  isLoading = false,
  className,
  title = 'New Story',
  ariaLabel = 'Start a new story',
  dataTour = 'new-project',
  disabled = false,
  blockedLabel
}: NewStoryHeroProps) {
  return (
    <HeroButton
      title={title}
      description={blockedLabel}
      busy={isLoading}
      disabled={Boolean(blockedLabel) || disabled}
      onClick={onClick}
      data-tour={dataTour}
      aria-label={ariaLabel}
      className={className}
    />
  );
}
